import SmoothScroll from "./components/SmoothScroll";
import AuroraBackground from "./components/AuroraBackground";
import CursorGlow from "./components/CursorGlow";
import ScrollProgress from "./components/ScrollProgress";
import Navbar from "./components/navbar";
import SectionConnector from "./components/SectionConnector";
import Header from "./components/header/Header";
import About from "./pages/about";
import Experience from "./pages/career";
import Skills from "./pages/experiences";
import Portfolio from "./pages/portfolio";
import Education from "./pages/education";
import Services from "./pages/services";
import Testimonials from "./pages/testimonials";
import Contact from "./pages/contact";
import Footer from "./components/footer";

function App() {
  return (
    <SmoothScroll>
      <AuroraBackground />
      <CursorGlow />
      <ScrollProgress />
      <Navbar />

      <main className="relative z-10">
        <Header />
        <SectionConnector number={1} />
        <About />
        <SectionConnector number={2} flip />
        <Experience />
        <SectionConnector number={3} />
        <Skills />
        <SectionConnector number={4} flip />
        <Portfolio />
        <SectionConnector number={5} />
        <Education />
        <SectionConnector number={6} flip />
        <Services />
        <Testimonials />
        <Contact />
      </main>

      <Footer />
    </SmoothScroll>
  );
}

export default App;
